@if (!live) {
  <mat-card-title class="custom-card-title text-align-center">{{ 'VALIDATIONS.PASSWORD_REQUIREMENTS' | translate }}</mat-card-title>
  <mat-dialog-content>
    {{ 'VALIDATIONS.PASSWORD_CRITERIA' | translate }}
    <ng-container *ngTemplateOutlet="requirementsList"></ng-container>
  </mat-dialog-content>
} @else {
  <div class="password-requirements">
    <ng-container *ngTemplateOutlet="requirementsList"></ng-container>
  </div>
}

<ng-template #requirementsList>
  <ul>
    <li [class.valid]="true">
      <span>&nbsp; &nbsp; &nbsp; &nbsp; {{ 'VALIDATIONS.MUST_INCLUDE' | translate }}</span>
    </li>
    <li [class.valid]="isValid('hasUpperCase')">
      <span>{{ icon('hasUpperCase') }}</span>
      {{ 'VALIDATIONS.AT_LEAST_1_UPPERCASE_LETTER' | translate }} (A-Z)
    </li>
    <li [class.valid]="isValid('hasLowerCase')">
      <span>{{ icon('hasLowerCase') }}</span>
      {{ 'VALIDATIONS.AT_LEAST_1_LOWERCASE_LETTER' | translate }} (a-z)
    </li>
    <li [class.valid]="isValid('hasNumber')">
      <span>{{ icon('hasNumber') }}</span>
      {{ 'VALIDATIONS.AT_LEAST_1_DIGIT_0_9' | translate }}
    </li>
    <li [class.valid]="isValid('hasSpecialChar')">
      <span>{{ icon('hasSpecialChar') }}</span>
      {{ 'VALIDATIONS.AT_LEAST_1_SPECIAL_CHARACTER' | translate }}
    </li>
    <li [class.valid]="isValid('hasValidLength')">
      <span>{{ icon('hasValidLength') }}</span>
      {{ 'VALIDATIONS.PASSWORD_LENGTH_BETWEEN_8_16' | translate }}
    </li>
    <li [class.valid]="isValid('noSequentialChars')">
      <span>{{ icon('noSequentialChars') }}</span>
      {{ 'VALIDATIONS.MUST_NOT_INCLUDE' | translate }} {{ 'VALIDATIONS.ALPHABETICAL_NUMERICAL_SEQUENCES' | translate }}
    </li>
    <li [class.valid]="isValid('noWhitespace')">
      <span>{{ icon('noWhitespace') }}</span>
      {{ 'VALIDATIONS.MUST_NOT_INCLUDE' | translate }} {{ 'VALIDATIONS.WHITESPACE_CHARACTERS' | translate }}
    </li>
  </ul>
</ng-template>
